export default [
  {
    id: 1,
    slug: 'architecture',
    title: 'WeSaidSo Leight Weigth Architecture Workshop',
    icon: 'ni ni-vector',
    text1: true,
    text2: true,
    text3: false,
  },
  {
    id: 2,
    slug: 'developing',
    title: 'WeSaidSo Java Developing Workshop',
    icon: 'ni ni-vector',
    text1: true,
    text2: false,
    text3: false,
  }
]